/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { CurrentToPrevious } from './tableHead';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getInvoiceComparisonReport } from '../Store/action';

const DisplayCurrentToPrevious = () => {
  const gridRef = React.useRef();

  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      quarterFrom: getQuarter,
      invoiceComparison: getInvoicecomparison,
    },
  } = useSelector((state) => state?.sharedState?.CurrentPreviousQuarter);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [current, setCurrent] = React.useState();
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // invoice comparison api

  React.useEffect(() => {
    dispatch(
      getInvoiceComparisonReport({
        rebateProgram: getRebateProgramName?.rebateProgramCd,
        quarter: getQuarter,
      })
    );
  }, []);

  React.useEffect(() => {
    let data = getInvoicecomparison?.invoiceComparisonReportVO || [];
    data = data.map((item) => {
      return {
        ...item,
        billedQty: item.billedQty ? item.billedQty.toFixed(4) : '0.0000',
        billedAmt: item.billedAmt
          ? parseFloat(item.billedAmt.toFixed(2))
          : '0.00',
        prevBilledAmt: item.prevBilledAmt
          ? parseFloat(item.prevBilledAmt.toFixed(2))
          : '0.00',
        prevBilledQty: item.prevBilledQty
          ? item.prevBilledQty.toFixed(4)
          : '0.0000',
      };
    });
    setCurrent(data);
  }, [getInvoicecomparison]);
  // filter total
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });

    setFilteredRow(updatedRowData);
  };
  // pdf header

  let secondInfo = '';
  let thirdInfo = '';

  secondInfo = `Quarter: ${getQuarter}`;
  thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  // pinned row
  const [displayedRows, setDisplayedRows] = React.useState(current ?? []);

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : current;

    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    if(property === 'billedQty' || property === 'prevBilledQty'){
      return data ? parseFloat(data.toFixed(4)) : 0.0;
    }else{
      return data ? parseFloat(data.toFixed(2)) : 0.0;
    }
  };
  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        mfgId: 'Total',
        billedAmt: sum('billedAmt'),
        billedQty: sum('billedQty'),
        prevBilledAmt: sum('prevBilledAmt'),
        prevBilledQty: sum('prevBilledQty'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [current, filteredRows]);
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Current to Previous Quarter Invoice"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Quarter "
                        id="Quarter1"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Quarter1' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={getQuarter}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
          <TableGridWithFeatures
            data-testid="Current-to-Previous-Quarter-Invoice"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={current}
            columnDefs={CurrentToPrevious}
            exportFile
            animateRows
            sideBar={false}
            fileName="PrevQtrInvoiceCOmpare"
            reportName="Current to Previous Quarter Invoice Comparison Report"
            isScrollOn
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            onCellFocused={onCellFocused}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ secondInfo, thirdInfo }}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 30) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DisplayCurrentToPrevious;
